import { onSnapshot, doc, setDoc, getDoc } from "firebase/firestore";
import { deleteObject, getBlob, getDownloadURL, ref, uploadString } from "firebase/storage";
import { firestore, storage } from "../services/FirebaseService";
import { sortNotificationsByDate, toBase64 } from "./HelperFunctions";
import { IFile, INotification } from "./Interfaces";
import { getAuth, signInWithCustomToken, signOut, signInAnonymously } from "firebase/auth";

export async function firebaseSignIn(token: string) {

    const auth = getAuth();

    let loggedIn = false;

    await signInAnonymously(auth).then(() => {
        loggedIn = true;
    }).catch((e: any) => {
        loggedIn = false;
    });

    // await signInWithCustomToken(auth, token).then(() => {
    //     loggedIn = true;
    // }).catch(() => {
    //     loggedIn = false;
    // });

    return loggedIn;
}

export async function firebaseSignOut() {

    const auth = getAuth();

    signOut(auth);
}

export async function addMedia(file: string, fileName: string) {

    const storageRef = ref(storage, `/media/${fileName}`);
    let downloadLink = "";

    await uploadString(storageRef, file, "data_url").then(async (snapshot) => {
        await getDownloadURL(snapshot.ref).then((link: string) => {
            downloadLink = link;
        })
    })

    return downloadLink;
}

export async function getDocumentMedia(docId: string, setMedia: CallableFunction) {
    try {
        const docRef = doc(firestore, "media", docId);
        const docSnap = await getDoc(docRef);

        let files: IFile[] = docSnap.data()?.media;

        if (!files) {
            setMedia([]);
            return false;
        }

        const updatedFiles = files.map(file => ({ ...file, saved: true }));
        setMedia(updatedFiles);
        return true;
    } catch (err) {
        return false;
    }
}

export async function getDocument(docId: string, setReport: CallableFunction) {
    try {
        const docRef = doc(firestore, "documents", docId);
        const docSnap = await getDoc(docRef);

        setReport(docSnap.data());

        return true;
    } catch (err) {
        return false;
    }
}

export async function getFirebaseUser(docId: string, setFirebaseUser: CallableFunction) {
    onSnapshot(doc(firestore, "users", docId), ((snapshot) => {
        let data = snapshot.data() as any;
        if (data) {
            let sortedNotifications = sortNotificationsByDate(data?.notifications)
            Object.assign(data, { notifications: sortedNotifications });

            setFirebaseUser((data));
        }
    }));
}

export async function updateNotifications(docId: string, notifications: INotification[]) {
    try {
        await setDoc(doc(firestore, "users", docId), { notifications: notifications });
        return true;
    } catch (err) {
        return false;
    }
}

export async function createMediaDocument(docId: string, media: IFile[]) {
    try {
        await setDoc(doc(firestore, "media", docId), { media: media });
        return true;
    } catch (err) {
        return false;
    }
}

export async function downloadMedia(props: { fileName: string, downloadingName: string }) {
    getBlob(ref(storage, `/media/${props.fileName}`)).then(async (value) => {

        let base64: any = await toBase64(value);

        let link = document.createElement("a");

        if (link.download !== undefined) {
            link.download = props.downloadingName
            link.href = base64;
            link.click();
            link.remove();
        }
    }).catch((error) => {
    });
}

export async function removeMedia(fileName: string) {
    const storageRef = ref(storage, `/media/${fileName}`);
    let state = false;
    await deleteObject(storageRef).then(() => {
        state = true;
    }).catch(() => {
        state = false;
    })
    return state;
}

export function getBase64(fileName: string, setBase64: CallableFunction) {
    getBlob(ref(storage, `/media/${fileName}`)).then(async (blob) => {
        let base64: any = await toBase64(blob);
        setBase64(base64);
    });
}

export async function getAudioFile(fileName: string, audio: any, setAudio: React.Dispatch<any>) {
    getBlob(ref(storage, `/media/${fileName}`)).then(async (value) => {

        let base64 = await toBase64(value);

        let val = audio;

        if (!val.includes(base64)) {
            val.push(base64);
        }

        setAudio(val);

        return base64;
    }).catch((error) => {
    });
}

export async function getMediaBlob(fileName: string): Promise<Blob | null> {
    const fileRef = ref(storage, `/media/${fileName}`);
    const blob = await getBlob(fileRef);
    return blob;
}

export async function fetchMediaArray(mediaId: string): Promise<IFile[]> {
    return new Promise((resolve) => {
        getDocumentMedia(mediaId, (mediaDocArr: IFile[]) => {
            resolve(mediaDocArr);
        });
    });
};